<template>
  <div 
    id="grad">
    <v-container
      fluid
      style="margin-bottom: 40px;">
      <v-layout 
        row 
        wrap>
        <v-flex 
          v-if="error" 
          xs12
          md6
          offset-md3>
          <app-alert 
            :text="error.message" 
            @dismissed="onDismissed"></app-alert>
        </v-flex>
        
        <v-flex 
          v-if="isNotVerified.isNotVerified" 
          xs12
          md6
          offset-md3>
          <v-alert 
            type="info" 
            color="rgba(0,0,0,0.3)"
            :value="isNotVerified.isNotVerified"
            class="roundedcard"
            dismissible 
            transition="scale-transition"
            @input="getSelf()['logout']">
            {{ isNotVerified.currentUserFireBaseEmail }} bitte verifiziere deinen Account!
            <br>
            <span class="caption">Das versenden der Email kann einige Minuten dauern.</span>
            <br>
            <small>
              Email nicht erhalten? 
              <span 
                style="cursor: pointer" 
                class="blue--text text--darken-3" 
                @click.prevent="sendVerificationMail">
                <strong>Erneut verschicken.</strong>
              </span>
            </small>
          </v-alert>
        </v-flex>

        <v-flex 
          v-if="!isNotVerified.isNotVerified && displayMailSent" 
          xs12
          md6
          offset-md3>
          <v-alert 
            type="info" 
            color="rgba(0,0,0,0.3)"
            value="Something"
            class="roundedcard"
            dismissible 
            transition="scale-transition"
            @input="displayMailSent = false">
            <div class="text-xs-center">
              <span><v-icon
                      color="white"
                      left>
                      fas fa-envelope-open-text
                    </v-icon>
                <strong>Email wird gesendet!</strong><br>
                <small>Das Versenden kann einige Minuten daueren.</small> <br>
                <small>Bitte überprüfe auch den Spam-Ordner deines Email-Accounts.</small>
              </span>
            </div>
          </v-alert>
        </v-flex>

        <v-flex 
          xs12>
          <v-layout
            v-if="refreshLoading"
            align-center
            justify-center
            row
            fill-height>
            <div
              class="no-freeze-spinner">
              <div
                id="no-freeze-spinner">
                <div>
                  <i>
                    <img
                      :src="getBrand"
                      class="wevent_icon_loading" 
                      alt="WeVent">
                  </i>
                  <i>
                    <img
                      :src="getBrand"
                      class="wevent_icon_loading" 
                      alt="WeVent">
                  </i>
                  <i>
                    <img
                      :src="getBrand"
                      class="wevent_icon_loading" 
                      alt="WeVent">
                  </i>
                </div>
              </div>
            </div>
          </v-layout>
          
       
          <v-layout 
            v-if="!refreshLoading && !user"
            row 
            wrap>
            <v-flex
              v-if="!isMobile || displayNews"
              md6
              xs12 
              class="text-xs-center">
              <v-layout
              
                row
                wrap
                class="text-xs-center">
                <v-flex
                  xs12>
                  <v-toolbar
                  
                    v-if="displayNews"
                    dense
                    flat
                    color="transparent"
                    class="mb-3">
                    <v-btn
                      class="font-weight-bold"
                      round
                      dark
                      color="rgba(255,255,255,0.2)"
                      @click="setDisplayNews">
                      <v-icon left>
                        fas fa-sign-in
                      </v-icon>
                      Login
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>
                      <span
                        class="headline"
                        style="color: rgba(255,255,255,0.9)">
                        WeVent <strong>News</strong>
                      </span>
                    </v-toolbar-title>
                  </v-toolbar>
                  <!-- <v-layout
                    row
                    wrap
                    justify-center
                    align-center
                    :class="displayNews ? 'mb-3' : 'mb-3'">
                    <span
                      class="font-weight-black"
                      style="color: rgba(255,255,255,0.9)">
                      GET ALL INFORMATION YOU NEED
                    </span>
                  </v-layout> -->
                  <v-layout 
                    v-if="!displayNews"

                    row 
                    wrap
                    justify-center
                    align-center
                    class="my-2 mx-4 text-xs-center">
                    <v-flex>
                      <hr class="dateline">
                    </v-flex>
                    <v-flex 
                      shrink 
                      class="mx-4 headline">
                      <span
                        class="display-1 "
                        style="color: rgba(255,255,255,0.9)">
                        WeVent <strong>News</strong>
                      </span>
                    </v-flex>
                    <v-flex>
                      <hr class="dateline">
                    </v-flex>
                  </v-layout>
                  <v-layout
                    v-if="!displayNews"
                    row
                    wrap
                    justify-center
                    align-center>
                    <span
                      class="font-weight-black"
                      style="color: rgba(0,0,0,0.3)">
                      GET ALL THE INFORMATION YOU DESIRE
                    </span>
                  </v-layout>
                </v-flex>
                <v-flex
                  id="blog"
                  style="border: 2px solid rgba(255,255,255,0.5); border-radius: 32px; background-color: rgba(0,0,0,0.07);"
                  
                  xs12
                  :class="displayNews ? '' : 'mt-2'"
                  class="text-xs-center px-3">
                  <app-wordpress-blog></app-wordpress-blog>
                </v-flex>
              </v-layout> 
              <!-- <v-btn
                dark
                color="rgba(255,255,255,0.3)"
                class="mt-4"
                href="https://www.wevent-news.de">
                Read More ...
              </v-btn> -->
            </v-flex>

           
              
            <v-flex 
              v-if="displayNews === false"
              md6
              xs12
              class="text-xs-center pt-4">
              <app-login v-if="login"></app-login>

              <app-signup v-else></app-signup>
            </v-flex>

            <!-- <v-flex
              v-if="isMobile && !displayNews" 
              md6
              xs12
              class="text-xs-center pt-4">
              <v-btn
                fab
                style="z-index: 5"
                color="rgba(255,255,255,0.3)"
                dark
                @click.stop="setDisplayNews">
                <v-icon>
                  fas fa-rss
                </v-icon>
              </v-btn>
            </v-flex> -->
          </v-layout> 
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>


<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'

import Signup from '@/components/View_Authentication/Signup.vue'
import Login  from '@/components/View_Authentication/Login.vue'
import WordPressBlog  from '@/components/global_comps/WordPress/WordPressBlog.vue'

export default {
  components: {
    // eslint-disable-next-line
    "app-signup": Signup,
    // eslint-disable-next-line
    "app-login": Login,
    // eslint-disable-next-line
    "app-wordpress-blog": WordPressBlog
  },
  data () {
    return {
      // displayNews: false,
      displayMailSent: false,
    }
  },
 
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      displayNews: state => state.displayNews,
      login: state => state.navigation.login,
      getBrand: state => require('@/assets/' + state.brand),

    }), 
    ...mapGetters({
      user: 'user',
      error: 'error',
      isNotVerified: 'isNotVerified',
      // tokenName: 'tokenName',
      refreshLoading: 'refreshLoading'
    }),
    ...mapActions([
      'logout'
    ]),
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        console.log('Watch_User_ViewAuthentication.vue')
        // this.$router.push('/timeline')
        console.log('setRefreshLoadingToFalse_ViewAuthentication_watch')
        this.$store.commit('setRefreshLoading', false)
      }
    }
  },
  methods: {
    ...mapMutations([
      'setDisplayNews'
    ]),
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    sendVerificationMail () {
      this.$store.dispatch('sendVerificationMail')
      this.$store.commit('delIsNotVerified')
      this.displayMailSent = true
      console.log('Mail sent')
    },
    getSelf () {
      return this
    }
  }
}
</script>

<style scoped>
#grad {
  /* background-image: linear-gradient( rgba(255,0,0,1), rgba(255,0,0,0)); */
  background-image: linear-gradient(330deg, rgba(216,27,96,1), #eeff41);
  /* background-image: url('../../assets/Background.svg');
    background-size: 100% 100%; */
  /* border-bottom-right-radius: 80% 6%;
  border-bottom-left-radius: 20% 1%; */
  /* padding-bottom: 120px; */
    /* height: calc(100% - 80px) !important; */
    width: 100%;
    /* height: 86%; */
    height: 100%;
    position: relative;
}

/* img {
  border-bottom-right-radius: 50% 25%;
  border-bottom-left-radius: 50% 25%;
} */


.spinner {
  width: 80px;
  height: 80px;
  margin: 180px auto;
  background-color: #fff;

  border-radius: 100%;  
  -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
  animation: sk-scaleout 1.0s infinite ease-in-out;
}

@-webkit-keyframes sk-scaleout {
  0% { -webkit-transform: scale(0) }
  100% {
    -webkit-transform: scale(1.0);
    opacity: 0;
  }
}

@keyframes sk-scaleout {
  0% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 100% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
    opacity: 0;
  }
}



#no-freeze-spinner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  transition: all 0.1s linear;
  opacity: 0;
  height: 100vh;
  transform: scale(10);
  z-index: -1;
  /* background: rgba(0, 0, 0, 0.8); */
  }

.no-freeze-spinner #no-freeze-spinner {
  z-index: 9999;
  opacity: 0.5;
  transform: scale(1);
}


#no-freeze-spinner > div {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
  /* box-shadow: 0 0 0 2000px rgba(0, 0, 0, 0.0); */
  width: 100px;
  height: 100px;
  /* padding: 5px; */
}

@keyframes loadicons {
  0% {
    transform: scale(0) translate3d(0, 0, 0);
  }
  11% {
    transform: scale(1.2) translate3d(0, 0, 0);
  }
  22% {
    transform: scale(1) translate3d(0, 0, 0);
  }
  33% {
    transform: scale(0) translate3d(0, 0, 0);
  }
}


.no-freeze-spinner #no-freeze-spinner i {
  /* font-size: 24px; */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  color: #fff;
  /* width: 24px;
  height: 24px; */
  /* line-height: 1; */
  transform: scale(0) translate3d(0, 0, 0);
}
.no-freeze-spinner #no-freeze-spinner i:nth-of-type(1) {
  animation: loadicons 6s infinite ease-in-out;
}
.no-freeze-spinner #no-freeze-spinner i:nth-of-type(2) {
  animation: loadicons 6s 2s infinite ease-in-out;
}
.no-freeze-spinner #no-freeze-spinner i:nth-of-type(3) {
  animation: loadicons 6s 4s infinite ease-in-out;
}
.wevent_icon_loading {
  transform: translateX(calc(-50% + 50px));
  width: 320px !important;
  -webkit-filter: invert(0.9) sepia(1) saturate(1) hue-rotate(175deg);
  filter: invert(0.9) sepia(1) saturate(1) hue-rotate(175deg);
}

#blog {
  position: inherit;
  width: 100% !important;
  height: 72vh;
  top: 0;
  bottom: 0;
  overflow-x: visible;
  overflow-y: scroll;
}

.dateline {
  border: 1px solid rgba(255,255,255,0.9);
}
</style>
